import { createContext, useContext, type ReactNode } from "react";
import type { TokensPessoaisGateway } from "../infrastructure/tokens-pessoais.gateway";

const Contexto = createContext<TokensPessoaisGateway | null>(null);

export function ProvedorDeMcp({
  gateway,
  children,
}: {
  readonly gateway: TokensPessoaisGateway;
  readonly children: ReactNode;
}) {
  return <Contexto.Provider value={gateway}>{children}</Contexto.Provider>;
}

export function useTokensPessoaisGateway(): TokensPessoaisGateway {
  const gateway = useContext(Contexto);
  if (!gateway) {
    throw new Error("useTokensPessoaisGateway fora do ProvedorDeMcp");
  }
  return gateway;
}
